<template>
  <div
    v-if="titledActions"
    class="mega-menu-button-region"
    :class="moreThanOne(content)"
  >
    <div
      v-for="(item, index) in content"
      :key="index"
      class="banner-action-item"
    >
      <HighlightButton
        v-if="item.linkTitle && item.linkUrl"
        :button-type="item.buttonType"
        :button-size="item.buttonSize"
        :button-style="item.buttonStyle"
        :url="item.linkUrl"
        :title="item.linkTitle"
        :url-new-window="item.linkTarget"
        block
      />
    </div>
  </div>
</template>

<script>
import HighlightButton from './components/button/highlight-button.vue'
export default {
  name: 'button-block',
  components: {
    HighlightButton

  },
  props: {
    content: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    titledActions() {
      return this.content?.some(
        (item, index, arr) => item.linkTitle && item.linkTitle.length > 1
      )
    }

  },
  methods: {
    moreThanOne(item) {
      if (Object.keys(item).length > 1) {
        return 'actions'
      }
    },
    hasItem(item) {
      return Object.keys(item).length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';
 .mega-menu-button-region {
    display:flex;
    gap: 1em;
    //--grid-item-min-width: 10em;
    //grid-template-columns: repeat( auto-fill, minmax(min(var(--grid-item-min-width), 100%), 1fr) );
 }
</style>
